import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const RollerBlinds = () => {

      const whatWeOfferRef = useRef(null); 
        
          const scrollToSection = () => {
            if (whatWeOfferRef.current) {
              whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
            }
          };
   const features = [
     {
       title: "Light Control",
       description:
         "Easily adjust light levels with dual-layered fabrics for perfect ambiance and privacy.",
     },
     {
       title: "Modern Design",
       description:
         "Sleek and elegant Roller blinds complement any home decor style effortlessly.",
     },
     {
       title: "Durability",
       description:
         "Crafted from high-quality materials, ensuring long-lasting performance and reliability.",
     },
     {
       title: "UV Protection",
       description:
         "Block harmful UV rays while still allowing natural light into your space.",
     },
     {
       title: "Energy Savings",
       description:
         "Improve insulation and reduce energy costs with light-filtering and blackout options.",
     },
     {
       title: "Custom Fit",
       description:
         "Tailored to your window dimensions, ensuring a perfect fit for any room.",
     },
   ];
   
   
     const [activeIndex, setActiveIndex] = useState(null);
   
     const toggleFAQ = (index) => {
       setActiveIndex(activeIndex === index ? null : index);
     };
   
     return (
       <div className=' font-playfair'>
   
{/* <section
  className="object-cover h-screen bg-cover bg-center flex flex-col justify-center items-center lg:items-start lg:text-left"
  style={{ backgroundImage: "url('images/roller.jpg')" }}
>
  <div className="px-8 sm:px-16 lg:px-24 text-center lg:text-left">
    <h1 className="text-5xl md:text-8xl xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
    Durable
    </h1>
    <h1 className="text-5xl md:text-8xl xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
    roller blinds
    </h1>
Button positioned below the text
<div className="mt-4 lg:mt-10 flex justify-center lg:justify-start">
    <button
      onClick={scrollToSection}
      className="text-black bg-white text-xl md:w-52 px-6 py-2"
    >
      LEARN MORE
    </button>
  </div>
  </div>
</section> */}

<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-20 "
   style={{ backgroundImage: "url('images/roller.jpg')" }}
 >
  <div className="px-8 sm:px-16 lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    Roller 
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl">
      Blinds
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>

<div className="flex flex-col xl:gap-20  xl:px-20 2xl:px-32">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">Roller Blinds</h1>
        </header>

        {/* About Roller Blinds */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Roller Blinds?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Roller blinds are versatile window treatments that provide enhanced convenience, privacy,
          and energy efficiency. Designed to suit your needs, they offer a stylish and functional solution for any space.
          </p>
        </section>

        {/* Benefits of Roller Blinds */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Roller blinds offer a simple and effective way to enhance privacy, control light, and improve energy efficiency. Easily adjust the blinds to suit your needs, providing
            comfort and style for any space. Perfect for maintaining privacy while allowing natural light to filter through
            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Roller Blinds</h2>

        </section>

        {/* How Roller Blinds Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do Roller Blinds Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Roller blinds are a practical solution for controlling light and privacy. Easily adjust the blinds to suit your needs, providing a smooth and quiet operation.
          Perfect for enhancing comfort and energy efficiency in any space, while maintaining a stylish and functional look
          </p>
        </section>
        </div>
   
   {/* Content Section */}
  <section className="py-16 px-2 md:px-6">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
    Transform Your Space with <br/>Motorized Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Effortless Morning Comfort</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day effortlessly with roller blinds that let in natural light at just the right moment. Wake up to a gradual opening of your blinds, resembling a gentle sunrise,
        offering a refreshing start that helps you feel energized and ready for the day ahead
        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roller2.jpg"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Customized Comfort Throughout the Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Whether it's a sunny afternoon or a cozy rainy day, roller blinds give you full control over the light in your space. Effortlessly adjust 
        them to set the perfect ambiance for work, relaxation, or entertaining, all with just a touch of a button. 
        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roller3.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Evening Elegance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Set the ideal evening mood with roller blinds that adjust easily to your preferred level of privacy and light. Whether you're seeking a dim, cozy atmosphere for relaxation 
        or a brighter setting for social gatherings, roller blinds provide the perfect solution for any occasion.  
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roller1.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>
   
        
           {/* Features */}
        
           <section className="mb-16 bg-white p-8  max-w-6xl mx-auto xl:pt-20">
         <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
           Key Features of Roller Blinds
         </h2>
         <div>
           {features.map((feature, index) => (
             <div
               key={index}
               className="border-b border-gray-400 p-3 mb-4 "
             >
               <div
                 className="flex justify-between items-center cursor-pointer"
                 onClick={() => toggleFAQ(index)}
               >
                 <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
                   {feature.title}
                 </h3>
                 <button
                   className="text-xl md:text-4xl font-bold text-gray-600"
                   aria-label="Toggle FAQ"
                 >
                   {activeIndex === index ? "-" : "+"}
                 </button>
               </div>
               {activeIndex === index && (
                 <p className="text-gray-600 mt-2 text-base md:text-3xl">{feature.description}</p>
               )}
             </div>
           ))}
         </div>
       </section>
         
   
   
          
       </div>
   );
 };

export default RollerBlinds;
// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// const RollerBlinds = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       gsap.from('.roller-content', {
//         scrollTrigger: {
//           trigger: '.roller-content',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         y: 50,
//         opacity: 0,
//         duration: 1
//       });

//       gsap.from('.gallery-item', {
//         scrollTrigger: {
//           trigger: '.gallery-grid',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         scale: 0.9,
//         opacity: 0,
//         duration: 0.8,
//         stagger: 0.2
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   return (
//     <section ref={sectionRef} className="py-20 bg-gradient-to-b from-white to-gray-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl font-bold text-gray-900 mb-4">Roller Blinds</h2>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Sleek, modern, and effortlessly stylish - our roller blinds combine form and function
//           </p>
//         </div>

//         <div className="roller-content mb-20">
//           <div className="relative h-[70vh] rounded-2xl overflow-hidden shadow-2xl mb-8">
//             <img
//               src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
//               alt="Roller Blinds Hero"
//               className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
//               <div className="absolute bottom-8 left-8 text-white">
//                 <h3 className="text-3xl font-bold mb-2">Premium Collection</h3>
//                 <p className="text-xl mb-4">Starting from $199</p>
//                 <button className="bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
//                   Explore More
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8 mb-16">
//             <div className="bg-white p-8 rounded-xl shadow-lg">
//               <h3 className="text-xl font-semibold mb-4">Modern Elegance</h3>
//               <p className="text-gray-600 mb-6">
//                 Clean lines and contemporary designs that complement any interior style
//               </p>
//               <img
//                 src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                 alt="Modern Design"
//                 className="w-full h-48 object-cover rounded-lg"
//               />
//             </div>

//             <div className="bg-white p-8 rounded-xl shadow-lg">
//               <h3 className="text-xl font-semibold mb-4">Light Control</h3>
//               <p className="text-gray-600 mb-6">
//                 Perfect balance of natural light and privacy for your space
//               </p>
//               <img
//                 src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                 alt="Light Control"
//                 className="w-full h-48 object-cover rounded-lg"
//               />
//             </div>

//             <div className="bg-white p-8 rounded-xl shadow-lg">
//               <h3 className="text-xl font-semibold mb-4">Smart Operation</h3>
//               <p className="text-gray-600 mb-6">
//                 Roller options for seamless control at your fingertips
//               </p>
//               <img
//                 src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                 alt="Smart Features"
//                 className="w-full h-48 object-cover rounded-lg"
//               />
//             </div>
//           </div>
//         </div>

//         <div className="text-center mb-12">
//           <h3 className="text-3xl font-bold text-gray-900 mb-4">Style Gallery</h3>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Explore our collection of stunning installations
//           </p>
//         </div>

//         <div className="gallery-grid grid grid-cols-2 md:grid-cols-4 gap-4">
//           {[1, 2, 3, 4].map((item) => (
//             <div key={item} className="gallery-item group relative aspect-square overflow-hidden rounded-lg">
//               <img
//                 src={`https://images.unsplash.com/photo-${item === 1 ? '1513519245088-0e12902e35a0' : item === 2 ? '1513694203232-719a280e022f' : item === 3 ? '1484154218962-a197022b5858' : '1513519245088-0e12902e35a0'}?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80`}
//                 alt={`Gallery Image ${item}`}
//                 className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//               />
//               <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-opacity duration-300 flex items-center justify-center">
//                 <button className="opacity-0 group-hover:opacity-100 bg-white text-gray-900 px-6 py-2 rounded-lg font-semibold transform translate-y-4 group-hover:translate-y-0 transition-all duration-300">
//                   View Details
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default RollerBlinds;